module.exports = [{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-manifest@5.15_0f129c9e7da1be88f29c59fec0a987c8/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"icon":"src/images/icon.png","name":"PaddyN'Canal","short_name":"PaddyN'Canal","start_url":"/","background_color":"#ffffff","theme_color":"#f59e0b","display":"standalone","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"05323d1626ce2febf349bdaba42aa42e"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/.pnpm/gatsby@5.15.0_babel-eslint@_231fb22a5a1fd305395239616b9fa36c/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
